import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from "flowbite-react";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { CommissionLevelsTable } from "./commission-levels/CommissionLevelsTable";
import { AddCommissionLevelModal } from "./commission-levels/AddCommissionLevelModal";
import { getCommissionLevels } from "../../services/commission-levels";
import type { CommissionLevel } from "../../types/commission-level";

interface CommissionLevelsModalProps {
  show: boolean;
  onClose: () => void;
}

export const CommissionLevelsModal: FC<CommissionLevelsModalProps> = ({
  show,
  onClose,
}) => {
  const [levels, setLevels] = useState<CommissionLevel[]>([]);

  const fetchLevels = async () => {
    try {
      const data = await getCommissionLevels();
      setLevels(data);
    } catch (error) {
      console.error("Error fetching commission levels:", error);
    }
  };

  useEffect(() => {
    if (show) {
      fetchLevels();
    }
  }, [show]);

  return (
    <Modal show={show} onClose={onClose} size="4xl">
      <ModalHeader>Provisions-Level verwalten</ModalHeader>
      <ModalBody>
        <div className="mb-4 flex justify-end">
          <AddCommissionLevelModal onUpdate={fetchLevels} />
        </div>
        <CommissionLevelsTable levels={levels} onUpdate={fetchLevels} />
      </ModalBody>
      <ModalFooter>
        <Button color="gray" onClick={onClose}>
          Schließen
        </Button>
      </ModalFooter>
    </Modal>
  );
};
